import { RcFile } from 'antd/es/upload';
import axios, { AxiosRequestConfig } from 'axios';

import { ApiRoutes, QueryError } from '@/common/interfaces';
import { apiExecutor, buildMutation, buildQuery } from '@/common/services';

import { Site, SiteArchivesExportFormFields, SiteArchivesKeys } from '@/modules/Sites';

export const useImportArchiveSitesMutation = (siteId: string) =>
  buildMutation<void, QueryError, { archive: RcFile; onUploadProgress: AxiosRequestConfig['onUploadProgress'] }>(
    [SiteArchivesKeys.UploadArchive, siteId],
    async ({ archive, onUploadProgress }) => {
      const { data: { signedUrl, gcsPath } } = await apiExecutor.post<{ signedUrl: string; gcsPath: string }>(
        ApiRoutes.SitesImportArchiveSignedUrl.replace(':siteId', siteId),
      );

      await axios.put(signedUrl, archive, {
        headers: { 'Content-Type': archive.type || 'application/octet-stream' },
        onUploadProgress,
      });

      await apiExecutor.post<void>(ApiRoutes.SitesImportArchiveConfirm.replace(':siteId', siteId), {
        fileName: archive.name,
        mimeType: archive.type || 'application/octet-stream',
        size: archive.size,
        gcsPath,
      });
    },
  );

export const useGetArchivesSitesQuery = (siteId: string) =>
  buildQuery<Site['archives'], QueryError>([SiteArchivesKeys.GetArchives, siteId], async () => {
    const { data } = await apiExecutor.get<Site['archives']>(ApiRoutes.SitesArchives.replace(':siteId', siteId));
    return data;
  });

export const useExportArchiveSitesMutation = (siteId: string) =>
  buildMutation<void, QueryError, SiteArchivesExportFormFields>(
    [SiteArchivesKeys.ExportArchive, siteId],
    async (postData: SiteArchivesExportFormFields) => {
      await apiExecutor.post(ApiRoutes.SitesExportArchive.replace(':siteId', siteId), { ...postData });
    },
  );
